import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList } from "vue"
import _imports_0 from '@/assets/image/customer_service_qr.jpg'
import _imports_1 from '@/assets/image/WechatIMG58.jpg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "160",
  alt: "customer_service_qr"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "100%",
  alt: ""
}, null, -1)

import {reactive, ref} from "vue";
import {PlusOutlined} from "@ant-design/icons-vue";
import {editor} from "@/app/editor";
import {IconFont} from "@/lib/util";
import {account} from "@/app/login";
import {IActivityGift} from "@/app/editor/types";
import BlockView from "@/components/block/BlockView.vue";
import BlockTitleView from "@/components/block/BlockTitleView.vue";
import {RecommendModuleV1} from "@/app/editor/modules/recommend/v1/recommend_v1";
import BlockContentItemValue from "@/components/block/BlockContentItemValue.vue";
import BlockContentItemKey from "@/components/block/BlockContentItemKey.vue";
import BlockContentBox from "@/components/block/BlockContentBox.vue";
import GiftItemView from "@/app/editor/views/GiftItemView.vue";
import GiftPickView from "@/app/editor/views/GiftPickView.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RecommendSetup',
  props: {
    index: {}
  },
  setup(__props: any) {


const props = __props
const recommend = editor.activity?.modules[props.index] as RecommendModuleV1

const info = reactive({
  item: {open: false, freshman_count: 3, gifts: [] as IActivityGift[]},
  pick: {open: false, gift: null as null | IActivityGift},
  doc: {open: false, link: ''}
})

const onDelete = (i: number) => {
  recommend.config.gift_rules.splice(i, 1)
}

const rule = ref()
const itemRules = {
  freshman_count: [{
    validator: async (_r: unknown, v: number) => {
      if (v > 0) return Promise.resolve()
      else return Promise.reject('推荐数量必填')
    }
  }]
}

const onPick = () => {
  if (info.pick.gift && !info.item.gifts.includes(info.pick.gift)) info.item.gifts.push(info.pick.gift)
  info.pick.open = false
  info.pick.gift = null
}

const addItem = () => {
  rule.value.validate().then(() => {
    recommend.config.gift_rules.push({freshman_count: info.item.freshman_count, gifts: info.item.gifts})
    cleanItem()
  }).catch((rs: unknown) => {
    console.log(rs)
  })
}
const cleanItem = () => {
  info.item.gifts = []
  info.item.freshman_count = 0
  info.item.open = false
}

const onOpenDoc = () => {
  info.doc.open = true
  info.doc.link = 'https://mp.weixin.qq.com/s/7OB8IsbGFGwDK2hP56lPzA'
}

return (_ctx: any,_cache: any) => {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_typography_link = _resolveComponent("a-typography-link")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table_summary_cell = _resolveComponent("a-table-summary-cell")!
  const _component_a_table_summary_row = _resolveComponent("a-table-summary-row")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_a_typography = _resolveComponent("a-typography")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(recommend) && _unref(editor).activity)
      ? (_openBlock(), _createBlock(BlockView, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(BlockTitleView, null, {
              default: _withCtx(() => [
                _createVNode(_unref(IconFont), {
                  type: `icon-${_unref(recommend).icon}`,
                  style: {"padding-right":"8px"}
                }, null, 8, ["type"]),
                _createTextVNode(" " + _toDisplayString(_unref(recommend).title), 1)
              ]),
              _: 1
            }),
            _createVNode(BlockContentBox, null, {
              default: _withCtx(() => [
                _createVNode(BlockContentItemKey, null, {
                  default: _withCtx(() => [
                    _createTextVNode("分销设置")
                  ]),
                  _: 1
                }),
                _createVNode(BlockContentItemValue, null, {
                  default: _withCtx(() => [
                    (_unref(recommend).distributionAvailable())
                      ? (_openBlock(), _createBlock(_component_a_flex, {
                          key: 0,
                          vertical: "",
                          gap: "small"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_a_switch, {
                                checked: _unref(recommend).config.distribution_rule.enable,
                                "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_unref(recommend).config.distribution_rule.enable) = $event))
                              }, null, 8, ["checked"])
                            ]),
                            (_unref(recommend).config.distribution_rule.enable)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                  _createVNode(_component_a_input_number, {
                                    "addon-before": "一级分佣比例",
                                    "addon-after": "%",
                                    value: _unref(recommend).config.distribution_rule.percents[0],
                                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(recommend).config.distribution_rule.percents[0]) = $event)),
                                    min: 1,
                                    max: _unref(recommend).max()
                                  }, null, 8, ["value", "max"])
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(recommend).config.distribution_rule.enable)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                  _createVNode(_component_a_input_number, {
                                    "addon-before": "二级分佣比例",
                                    "addon-after": "%",
                                    value: _unref(recommend).config.distribution_rule.percents[1],
                                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(recommend).config.distribution_rule.percents[1]) = $event)),
                                    max: _unref(recommend).max()-_unref(recommend).config.distribution_rule.percents[0]
                                  }, null, 8, ["value", "max"])
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(recommend).config.distribution_rule.enable)
                              ? (_openBlock(), _createBlock(_component_a_typography_text, {
                                  key: 2,
                                  type: "secondary"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 分佣比例是在线支付金额的百分比 ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_unref(recommend).config.distribution_rule.enable)
                              ? (_openBlock(), _createBlock(_component_a_typography_text, {
                                  key: 3,
                                  type: "secondary"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 当前授权的最大分账比率为: "),
                                    _createVNode(_component_a_typography_text, { strong: "" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(recommend).max()) + "%", 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createTextVNode(" ( "),
                                    _createVNode(_component_a_typography_link, {
                                      onClick: onOpenDoc,
                                      class: "tip-text"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("查看如何修改最大分账比率")
                                      ]),
                                      _: 1
                                    }),
                                    _createTextVNode(" ) ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_unref(recommend).config.distribution_rule.enable)
                              ? (_openBlock(), _createBlock(_component_a_collapse, { key: 4 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_collapse_panel, { header: "更多" }, {
                                      default: _withCtx(() => [
                                        _createVNode(BlockContentBox, null, {
                                          default: _withCtx(() => [
                                            _createVNode(BlockContentItemKey, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode("成为分销员的条件")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(BlockContentItemValue, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_radio_group, {
                                                  value: _unref(recommend).config.distribution_rule.props.require,
                                                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(recommend).config.distribution_rule.props.require) = $event))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_radio, { value: "none" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("首次打开链接")
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_a_radio, { value: "pay" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("首次购买")
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }, 8, ["value"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(BlockContentItemKey, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode("成为下级的条件")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(BlockContentItemValue, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_radio_group, {
                                                  value: _unref(recommend).config.distribution_rule.props.bind,
                                                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(recommend).config.distribution_rule.props.bind) = $event))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_radio, { value: "view" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("首次打开链接")
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_a_radio, { value: "order" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("首次下单")
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_a_radio, { value: "pay" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("首次购买")
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }, 8, ["value"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(BlockContentItemKey, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode("推广排行榜")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(BlockContentItemValue, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_radio_group, {
                                                  value: _unref(recommend).config.distribution_rule.props.show_list,
                                                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(recommend).config.distribution_rule.props.show_list) = $event))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_radio, { value: "hide" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("不显示")
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_a_radio, { value: "count" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("显示(邀请人数榜)")
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_a_radio, { value: "sum" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("显示(佣金榜)")
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }, 8, ["value"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_a_flex, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_popover, {
                              title: _unref(account).shop?.wx_mch_id == null ? '你还没有申请门店的收款商户' : '您的收款商户未开通分账'
                            }, {
                              content: _withCtx(() => [
                                _createVNode(_component_a_flex, { gap: "small" }, {
                                  default: _withCtx(() => [
                                    _hoisted_3,
                                    _createVNode(_component_a_flex, {
                                      vertical: "",
                                      gap: "small",
                                      justify: "center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_typography_title, { level: 4 }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("店家活动宝 - 张老师")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_typography_text, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" 联系我，" + _toDisplayString(_unref(account).shop?.wx_mch_id == null ? '协助您免费开通收款商户' : '免费协助您完成授权分账') + "。 ", 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_typography_text, { type: "secondary" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("微信扫描二维码，添加我的企业微信")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_a_switch, {
                                  disabled: "",
                                  checked: _unref(recommend).config.distribution_rule.enable
                                }, null, 8, ["checked"])
                              ]),
                              _: 1
                            }, 8, ["title"])
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }),
                _createVNode(BlockContentItemKey, null, {
                  default: _withCtx(() => [
                    _createTextVNode("推荐新" + _toDisplayString(_unref(editor).activity.data.tags.find(t => t.startsWith('t_se')) ? '生' : '客') + "送礼品 ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(BlockContentItemValue, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_table, {
                      "data-source": _unref(recommend).config.gift_rules,
                      columns: [{title:'条件',dataIndex:'type'},{title:'礼品',dataIndex:'gift'},{title:'操作',dataIndex:'opt'}],
                      bordered: "",
                      pagination: false
                    }, {
                      summary: _withCtx(() => [
                        _createVNode(_component_a_table_summary_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_table_summary_cell, { "col-span": 3 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "primary",
                                  disabled: _unref(recommend).config.gift_rules.length>=3,
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (info.item.open = true))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("添加 ")
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      bodyCell: _withCtx(({ column, record, index }) => [
                        (column.dataIndex==='type')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" 推荐 " + _toDisplayString(record.freshman_count) + " 名新" + _toDisplayString(_unref(editor).activity.data.tags.find(t => t.startsWith('t_se')) ? '生' : '客'), 1)
                            ], 64))
                          : (column.dataIndex==='gift')
                            ? (_openBlock(), _createBlock(_component_a_flex, {
                                key: 1,
                                gap: "large",
                                wrap: "wrap"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.gifts, (g) => {
                                    return (_openBlock(), _createBlock(GiftItemView, {
                                      key: g.gift_id,
                                      gift: g
                                    }, null, 8, ["gift"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024))
                            : (column.dataIndex==='opt')
                              ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                                  key: 2,
                                  title: "确定删除么？",
                                  onConfirm: ($event: any) => (onDelete(index))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_button, {
                                      danger: "",
                                      type: "default"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("删除")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onConfirm"]))
                              : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["data-source"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_drawer, {
              open: info.item.open,
              "onUpdate:open": _cache[9] || (_cache[9] = ($event: any) => ((info.item.open) = $event)),
              title: "添加规则",
              placement: "right",
              size: "large"
            }, {
              extra: _withCtx(() => [
                _createVNode(_component_a_flex, { gap: "small" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, { onClick: cleanItem }, {
                      default: _withCtx(() => [
                        _createTextVNode("取消")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: addItem
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("确定")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_form, {
                  ref_key: "rule",
                  ref: rule,
                  model: info.item,
                  rules: itemRules
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      name: "freshman_count",
                      label: _unref(editor).activity.data.tags.find(t => t.startsWith('t_se')) ? '推荐新生' : '推荐新客',
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_number, {
                          value: info.item.freshman_count,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((info.item.freshman_count) = $event)),
                          max: 100,
                          min: 1,
                          "addon-after": "名"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_a_form_item, {
                      name: "gifts",
                      label: "赠送礼品",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_flex, {
                          vertical: "",
                          gap: "small"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_a_button, {
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (info.pick.open=true)),
                                type: "primary",
                                disabled: info.item.gifts.length>=4
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_unref(PlusOutlined))
                                ]),
                                default: _withCtx(() => [
                                  _createTextVNode(" 礼品 ")
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _createVNode(_component_a_flex, {
                              wrap: "wrap",
                              gap: "small"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.item.gifts, (g, i) => {
                                  return (_openBlock(), _createBlock(GiftItemView, {
                                    key: i,
                                    gift: g,
                                    closeable: "",
                                    onOnClose: ($event: any) => (info.item.gifts.splice(i,1))
                                  }, null, 8, ["gift", "onOnClose"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              _: 1
            }, 8, ["open"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_a_drawer, {
      open: info.pick.open,
      "onUpdate:open": _cache[12] || (_cache[12] = ($event: any) => ((info.pick.open) = $event)),
      title: "选择礼品",
      placement: "right",
      size: "large"
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_flex, { gap: "small" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              onClick: _cache[10] || (_cache[10] = () => {info.pick.open=false; info.pick.gift = null})
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: onPick
            }, {
              default: _withCtx(() => [
                _createTextVNode("确定")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(GiftPickView, {
          gift: info.pick.gift,
          "onUpdate:gift": _cache[11] || (_cache[11] = ($event: any) => ((info.pick.gift) = $event))
        }, null, 8, ["gift"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_drawer, {
      open: info.doc.open,
      "onUpdate:open": _cache[13] || (_cache[13] = ($event: any) => ((info.doc.open) = $event)),
      title: "查看如何修改最大分账比率",
      placement: "right",
      size: "large"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_typography, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_typography_title, { level: 4 }, {
              default: _withCtx(() => [
                _createTextVNode("在电脑端地址栏输入下面网址并打开：")
              ]),
              _: 1
            }),
            _createVNode(_component_a_typography_title, { level: 3 }, {
              default: _withCtx(() => [
                _createTextVNode("https://pay.weixin.qq.com")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_4
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})